import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-phs-confirmation',
  templateUrl: './phs-confirmation.component.html',
  styleUrls: ['./phs-confirmation.component.scss']
})
export class PhsConfirmationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
